module.exports = __webpack_public_path__ + "static/img/case1.552e3bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case1.jpg
// module id = BVOV
// module chunks = 1